import { FC } from "react";
import { observer } from "mobx-react-lite";
import { Row, Col } from "antd";
import { useHandleForm } from "../../../hooks/useHandleForm";
import {
  FormBlock,
  FormField,
  IButton,
} from "../../../ui-kit";
import DictionariesStore from "../../../store/dictionary";

import styles from "../styles.module.scss";


const CustomDictionaryForm: FC = observer(({values, groupId}) => {

  const initialValues = {
    title: values?.record?.title,
    name: values?.record?.name,
    description: values?.record?.description,
    parentGroupId: values?.record?.parentGroupId,
    dictionaryGroupId: values?.record?.groupId ?? groupId
  };
  const initialFocus = {};
  const {
    register,
    handleSubmit,
    watchAllField,
    isFocused,
    handleBlur,
    handleFocus,
    control,
    setValue,
  } = useHandleForm(null, initialValues, initialFocus);

  const onSubmit = (values) => {
    DictionariesStore.saveDict(values);
  };

  return (
    <form
      className={styles.SmsSettingsParamsForm}
      onSubmit={handleSubmit(onSubmit)}
    >
      <FormBlock>
        <Row gutter={[15, 20]}>
          <Col span={8}>
            <FormField
              label="Наименование справочника"
              name="title"
              register={register}
              type="text"
              isFocused={isFocused.title}
              currentValue={watchAllField.title}
              onFocus={handleFocus}
              onBlur={handleBlur}
              isRequired
            />
          </Col>
          <Col span={8}>
            <FormField
              label="Описание"
              name="description"
              register={register}
              type="text"
              isFocused={isFocused.description}
              currentValue={watchAllField.description}
              onFocus={handleFocus}
              onBlur={handleBlur}
              isRequired
            />
          </Col>
          <Col span={24} className="form-block__data-header">
            <IButton className={styles.UsersButton} type="submit" disabled={DictionariesStore.isUpdating.value}>
              Сохранить
            </IButton>
          </Col>
        </Row>
      </FormBlock>
    </form>
  );
});

export default CustomDictionaryForm;
